import React, { useState } from 'react'
import constant from '../../constant';
import { removeStorage } from '../../utils';

const Logout = () => {

    useState(() => {
        document.title = 'Logout';
        removeStorage('rsc_cache')
        removeStorage(constant.keys.token);
        removeStorage(constant.keys.userDetails);
        removeStorage(constant.keys.remeber_me);
        removeStorage(constant.keys.loggedIn);
        localStorage.clear();

        window.location.href = constant.component.login.url;

    }, [])

    return (
        <div></div>
    )
}

export default Logout;